import { Database } from "./databases"

export const getDatabaseString = () => {
  if (process.env.NODE_ENV === "development") {
    return Database.CHRONOS_DEV
  } else {
    return Database.CHRONOS_PROD
  }
}

/**
 * Type alias for a serialized string representation of a type.
 * This helps document that a string is actually a serialized version of T.
 */
export type Serialized<T> = string & { __serialized: T }

export function serialize<T>(data: T): Serialized<T> {
  return JSON.stringify(data) as Serialized<T>
}

export function deserialize<T>(json: string): T {
  return JSON.parse(json) as T
}
